import { render, staticRenderFns } from "./SendRequest.vue?vue&type=template&id=04b9227e&"
import script from "./SendRequest.vue?vue&type=script&lang=js&"
export * from "./SendRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports